import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { Article } from '../../../interface';
import { dateFormatter } from '../../../helpers/utils';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueueGlobalCount } from '../../../store/emarsys/action';

const useImpressionNewsDetail = (
  firstRef: React.RefObject<HTMLElement>,
  news: Article,
  breadcrumbItems: IBreadcrumbs[],
  sectionName: string = ''
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isNewsDetailActive = getFlagValue(FLAG_ENUM.EMARSYS_NEWS_DETAIL);
      if (isAuth && isFlagActive && isNewsDetailActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'berita & tips',
          page_url: window.location.href,
          page_title: news?.titlePage || '',
          menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() || '',
          menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() || '',
          release_date: dateFormatter(news?.publishedDate),
          section_name: sectionName,
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }

        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueGlobalCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionNewsDetail;
